import React, { useState } from 'react'
import { IconBars, IconTimes } from './Icons'

const Header = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div>

            <header className="main-header" style={{ position: 'fixed', top: 0, left: 0, width: '100%', zIndex: 1000, background: 'rgba(11, 15, 23, 0.9)', backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)', borderBottom: '1px solid rgba(255, 255, 255, 0.08)', transition: 'all 0.3s ease' }}>
                <div className="container container-1620">
                    <div className="d-flex align-items-center justify-content-between py-3">
                        
                        {/* Brand Logo */}
                        <div className="logo d-flex align-items-center gap-2">
                            <a href="#home" style={{ fontSize: '22px', fontWeight: '800', color: '#F8FAFC', textDecoration: 'none', letterSpacing: '-0.5px' }}>
                                Manoj <span style={{ color: '#38BDF8' }}>Parmar</span>
                            </a>
                            <span style={{ display: 'inline-block', width: '6px', height: '6px', borderRadius: '50%', background: '#38BDF8', boxShadow: '0 0 10px #38BDF8' }}></span>
                        </div>

                        {/* Navigation Menu */}
                        <nav className="d-none d-lg-block">
                            <ul className="d-flex align-items-center gap-4 m-0 p-0" style={{ listStyle: 'none' }}>
                                <li><a href="#home" style={{ color: '#F8FAFC', fontSize: '15px', fontWeight: 600, textDecoration: 'none', transition: 'color 0.2s' }} className="hover:text-sky-400">Home</a></li>
                                <li><a href="#about" style={{ color: '#94A3B8', fontSize: '15px', fontWeight: 600, textDecoration: 'none', transition: 'color 0.2s' }} className="hover:text-sky-400">About</a></li>
                                <li><a href="#resume" style={{ color: '#94A3B8', fontSize: '15px', fontWeight: 600, textDecoration: 'none', transition: 'color 0.2s' }} className="hover:text-sky-400">Experience</a></li>
                                <li><a href="#skills" style={{ color: '#94A3B8', fontSize: '15px', fontWeight: 600, textDecoration: 'none', transition: 'color 0.2s' }} className="hover:text-sky-400">Skills</a></li>
                                <li><a href="#portfolio" style={{ color: '#94A3B8', fontSize: '15px', fontWeight: 600, textDecoration: 'none', transition: 'color 0.2s' }} className="hover:text-sky-400">Projects</a></li>
                                <li><a href="#contact" style={{ color: '#94A3B8', fontSize: '15px', fontWeight: 600, textDecoration: 'none', transition: 'color 0.2s' }} className="hover:text-sky-400">Contact</a></li>
                            </ul>
                        </nav>

                        {/* Right Mobile Toggle */}
                        <div className="d-flex align-items-center gap-3">
                            <button 
                                type="button" 
                                className="d-lg-none btn border-0 text-white p-2 d-flex align-items-center justify-content-center" 
                                onClick={() => setIsOpen(!isOpen)}
                                aria-label="Toggle Navigation"
                                style={{ background: 'rgba(255, 255, 255, 0.05)', borderRadius: '8px', width: '38px', height: '38px' }}
                            >
                                {isOpen ? <IconTimes /> : <IconBars />}
                            </button>
                        </div>
                    </div>

                    {/* Mobile Collapse Navigation Menu */}
                    {isOpen && (
                        <div className="d-lg-none py-3" style={{ borderTop: '1px solid rgba(255, 255, 255, 0.08)' }}>
                            <ul className="d-flex flex-column gap-3 m-0 p-0" style={{ listStyle: 'none' }}>
                                <li><a href="#home" onClick={() => setIsOpen(false)} style={{ color: '#F8FAFC', fontSize: '16px', fontWeight: 600, textDecoration: 'none' }}>Home</a></li>
                                <li><a href="#about" onClick={() => setIsOpen(false)} style={{ color: '#94A3B8', fontSize: '16px', fontWeight: 600, textDecoration: 'none' }}>About</a></li>
                                <li><a href="#resume" onClick={() => setIsOpen(false)} style={{ color: '#94A3B8', fontSize: '16px', fontWeight: 600, textDecoration: 'none' }}>Experience</a></li>
                                <li><a href="#skills" onClick={() => setIsOpen(false)} style={{ color: '#94A3B8', fontSize: '16px', fontWeight: 600, textDecoration: 'none' }}>Skills</a></li>
                                <li><a href="#portfolio" onClick={() => setIsOpen(false)} style={{ color: '#94A3B8', fontSize: '16px', fontWeight: 600, textDecoration: 'none' }}>Projects</a></li>
                                <li><a href="#contact" onClick={() => setIsOpen(false)} style={{ color: '#94A3B8', fontSize: '16px', fontWeight: 600, textDecoration: 'none' }}>Contact</a></li>
                            </ul>
                        </div>
                    )}
                </div>
            </header>




























        </div>
    )
}

export default Header